export default __webpack_public_path__ + "static/media/logo.effccab7.png";